import script from "./Home.vue?vue&type=script&setup=true&lang=js"
export * from "./Home.vue?vue&type=script&setup=true&lang=js"

import "./Home.vue?vue&type=style&index=0&id=f6f8d0a8&lang=scss"
import "./Home.vue?vue&type=style&index=1&id=f6f8d0a8&lang=scss&scoped=true"
script.__scopeId = "data-v-f6f8d0a8"

export default script